import { DEFAULT_LANGUAGE_KEY } from "../../Constants/MainKeys";
import { SET_LANGUAGE, SET_LANGUAGES } from "./actionTypes";

const initialState = {
  language: localStorage.getItem("language") && localStorage.getItem("language") !== (null || "null") ? localStorage.getItem("language") : "en",
  languages: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      localStorage.setItem("language", action.payload || DEFAULT_LANGUAGE_KEY)
      return {
        ...state,
        language: action.payload,
      };
    case SET_LANGUAGES:
      return {
        ...state,
        languages: action.payload || [],
      };

    default:
      break;
  }
  return state;
};

export default reducer;